import {capitalizeFirst} from '@wandb/weave/core/util/string';
import React from 'react';

import {useIsWorkspaceTemplateEnabled} from '../../WorkspaceTemplate/useIsWorkspaceTemplateEnabled';
import {useWorkspaceTemplateDrawerContext} from '../../WorkspaceTemplate/WorkspaceTemplateDrawerContextProvider';
import {OverflowMenuItem} from './OverflowMenu';

export const WorkspaceTemplateOverflowMenuItem = () => {
  const {isWorkspaceTemplateAccountPrivilegeEnabled} =
    useIsWorkspaceTemplateEnabled();

  const {
    openWorkspaceTemplateDrawer,
    workspaceTemplateMode,
    isWorkspaceTemplateActionDisplayed,
  } = useWorkspaceTemplateDrawerContext();

  if (!isWorkspaceTemplateActionDisplayed) {
    return null;
  }

  const displayName = `${capitalizeFirst(
    workspaceTemplateMode
  )} personal workspace template`;

  return (
    <OverflowMenuItem
      displayName={displayName}
      icon="settings-parameters"
      onSelect={openWorkspaceTemplateDrawer}
      disabled={!isWorkspaceTemplateAccountPrivilegeEnabled}
      tooltipContent={
        !isWorkspaceTemplateAccountPrivilegeEnabled
          ? 'Upgrade your plan in order to access this feature.'
          : undefined
      }
    />
  );
};
